export default "__VITE_ASSET__31c4c4b0__"